<template>
  <vue-good-table :columns="model.columnList" :rows="rowList">
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'action'">
        <div class="table-row--actions-cell">
          <button
            type="button"
            class="btn btn-success"
            @click="clickApprove(props.row)"
          >
            <blaise-icon icon="ACEPTAR" />
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="clickReject(props.row)"
          >
            <blaise-icon icon="RECHAZAR" />
          </button>
        </div>
      </span>
      <span v-else>
        {{ props.formattedRow[props.column.field] }}
      </span>
    </template>
  </vue-good-table>
</template>

<script>
import Swal from "sweetalert2";
// import the styles
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
  props: {
    rowList: Array,
    approveByIdFunction: Function,
    rejectByIdFunction: Function
  },
  components: {
    VueGoodTable
  },
  data() {
    return {
      model: {
        columnList: [
          {
            field: "action",
            sortable: false
          },
          {
            label: "CLIENTE",
            field: "nombreCliente"
          },
          {
            label: "FECHA",
            field: "fecha"
          },
          {
            label: "PRECIO",
            field: "basePriceString"
          },
          {
            label: "DESC. (%)",
            field: "porcentajeDescuentoString"
          },
          {
            label: "DESC. ($)",
            field: "descontadoString"
          },
          {
            label: "COBRADO",
            field: "cobradoString"
          }
        ]
      }
    };
  },
  methods: {
    async approveById(id) {
      try {
        await this.approveByIdFunction(id);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "Ocurrió un error inesperado al aceptar la venta."
        });
      }
    },
    async clickApprove(row) {
      Swal.fire({
        title: "Aceptar venta",
        text: "¿Seguro que desea aceptar esta venta?",
        icon: "question",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#28a745",
        cancelButtonColor: "rgb(125 133 140)",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        preConfirm: () => this.approveById(row.id)
      }).then(result => {
        // Si confirma que quiere aceptar
        if (result.isConfirmed) {
          Swal.fire({
            title: "Venta aceptada!",
            text: "Podrás ver esta venta en tu historial.",
            icon: "success"
          });
        }
      });
    },
    clickReject(row) {
      Swal.fire({
        title: "Rechazar venta",
        text: "¿Seguro que desea rechazar esta venta?",
        icon: "question",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "rgb(125 133 140)",
        confirmButtonText: "Si, rechazar",
        cancelButtonText: "Cancelar",
        preConfirm: () => this.rejectById(row.id)
      }).then(result => {
        // Si confirma
        if (result.isConfirmed) {
          Swal.fire({ title: "Venta rechazada!", icon: "success" });
        }
      });
    },
    async rejectById(id) {
      try {
        await this.rejectByIdFunction(id);
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Problemas",
          text: "Ocurrió un error inesperado al rechazar la venta."
        });
      }
    }
  }
};
</script>

<style scoped>
.table-row--actions-cell {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
}
</style>